import { useLingui } from "@lingui/react";
import { useLayoutEffect } from "react";
import { Outlet, RouteObject } from "react-router-dom";

import { LoginRoute } from "../features/auth/login/login-route";
import { TokenLoginRoute } from "../features/auth/login/token-login-route";
import { ForgotPasswordRoute } from "../features/auth/password/forgot-password-route";
import { ResetPasswordRoute } from "../features/auth/password/reset-password-route";
import { localeDir } from "../languages";
import { AppModel } from "./app-model";

/**
 * Routes open before login. Locales outside `clinicalLocales` translate only
 * what these render (`scripts/trim-catalogs.ts`), so a pre-login page belongs
 * here.
 */
export function publicRoutes(app: AppModel): RouteObject[] {
  return [
    {
      element: <PreLoginLayout />,
      children: [
        {
          path: "/login",
          element: <LoginRoute app={app} />,
        },
        {
          path: "/forgot-password",
          element: <ForgotPasswordRoute app={app} />,
        },
        {
          path: "/reset-password",
          element: <ResetPasswordRoute mode="reset" />,
        },
        {
          path: "/set-password",
          element: <ResetPasswordRoute mode="set" />,
        },
        {
          path: "/token-login",
          element: <TokenLoginRoute app={app} />,
        },
      ],
    },
  ];
}

/**
 * Lays the pre-login pages out in the locale's direction. Only these are
 * translated into the right-to-left languages, so the rest of the app, in
 * English, stays left-to-right.
 */
function PreLoginLayout() {
  const { i18n } = useLingui();

  useLayoutEffect(() => {
    document.documentElement.dir = localeDir(i18n.locale);
    return () => {
      document.documentElement.dir = "ltr";
    };
  }, [i18n.locale]);

  return <Outlet />;
}
